import { render, staticRenderFns } from "./MarkdownWidget.vue?vue&type=template&id=53071fdb&scoped=true&"
import script from "./MarkdownWidget.vue?vue&type=script&lang=ts&"
export * from "./MarkdownWidget.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownWidget.vue?vue&type=style&index=0&id=53071fdb&lang=scss&scoped=true&"
import style1 from "./MarkdownWidget.vue?vue&type=style&index=1&lang=css&"
import style2 from "@kangc/v-md-editor/lib/style/base-editor.css?vue&type=style&index=2&lang=css&"
import style3 from "@kangc/v-md-editor/lib/theme/style/github.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53071fdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer,VRow})
